/* ==========================================================================
   OliveDrab — product page upsell and cross sell

   1. Pairs well with: merchant pairings first when Shopify has any, pieces
      already in the bag left out, each card adds on its own.
   2. Complete the look: include ticks, sizes kept in step with the main
      size choice, a running plain total, one request for the whole set.
   3. Icons row: nothing the related row already shows is repeated.
   4. Add to bag bar on phones: mirrors the main form and presses its button.

   Every add announces itself with 'od:cart:added' then 'od:cart:changed',
   which the cart drawer and header count listen for.

   Everything here is an enhancement: without it the forms still post to the
   cart. No dependencies. Loaded with defer.
   Designed by Thriftizer.
   ========================================================================== */
(function () {
  'use strict';

  if (window.ODPdpUpsell) return;
  window.ODPdpUpsell = true;

  var cfg = window.ODConfig || {};
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  /* ------------------------------------------------------------ money */

  // Shopify's documented money format placeholders, applied to the shop's
  // own format string, so the total reads exactly like the prices Liquid
  // printed beside it.
  function formatMoney(cents, format) {
    var fmt = format || (cfg.money && cfg.money.format) || '{{amount}}';
    function group(n, precision, thousands, decimal) {
      var fixed = (n / 100).toFixed(precision);
      var parts = fixed.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    var match = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals': value = group(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = group(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = group(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = group(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': value = group(cents, 2, ' ', ','); break;
      default: value = group(cents, 2, ',', '.');
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  /* ------------------------------------------------------------- cart */

  function addItems(items) {
    return fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw new Error(data.description || data.message || 'Could not add to bag');
        return data;
      });
    }).then(function (data) {
      document.dispatchEvent(new CustomEvent('od:cart:added', { detail: { items: data, source: 'pdp-upsell' } }));
      document.dispatchEvent(new CustomEvent('od:cart:changed'));
      if (window.OD && window.OD.refreshCart) window.OD.refreshCart();
      return data;
    });
  }

  var cartIds = null;
  function cartProductIds() {
    if (cartIds) return cartIds;
    cartIds = fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : { items: [] }; })
      .then(function (cart) {
        var ids = {};
        (cart.items || []).forEach(function (it) { ids[String(it.product_id)] = true; });
        return ids;
      })
      .catch(function () { return {}; });
    return cartIds;
  }
  document.addEventListener('od:cart:changed', function () { cartIds = null; });

  function flash(btn, textEl, doneText, restoreText) {
    btn.classList.add('is-done');
    if (textEl) textEl.textContent = doneText;
    setTimeout(function () {
      btn.classList.remove('is-done');
      if (textEl) textEl.textContent = restoreText;
    }, 2200);
  }

  /* --------------------------------------------------- 1. pairs well with */

  function bindMini(form) {
    if (form.dataset.odMiniBound) return;
    form.dataset.odMiniBound = '1';

    var btn = $('[data-od-mini-add]', form);
    var text = $('[data-od-mini-add-text]', form);
    var msg = $('[data-od-mini-msg]', form);
    var select = $('[data-od-mini-select]', form);
    var price = $('[data-od-mini-price]', form);
    var restore = text ? text.textContent : '';

    if (select && price) {
      select.addEventListener('change', function () {
        var opt = select.selectedOptions && select.selectedOptions[0];
        if (opt && opt.dataset.priceText) price.textContent = opt.dataset.priceText;
      });
    }

    form.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      var idInput = $('[name="id"]', form);
      if (!idInput || !idInput.value) return;
      btn.disabled = true;
      if (msg) { msg.hidden = true; msg.textContent = ''; }
      addItems([{ id: Number(idInput.value), quantity: 1 }])
        .then(function () { flash(btn, text, 'Added', restore); })
        .catch(function (err) {
          if (msg) { msg.textContent = err.message; msg.hidden = false; }
        })
        .then(function () { btn.disabled = false; });
    });
  }

  function crossSell(root) {
    if (root.dataset.odXsellBound) return;
    root.dataset.odXsellBound = '1';

    var track = $('[data-od-xsell-track]', root);
    var want = parseInt(root.dataset.want, 10) || 3;
    if (!track) return;
    $$('[data-od-mini]', track).forEach(bindMini);

    // show the first `want` cards that are not already in the bag
    function settle(ids) {
      var shown = 0;
      $$('[data-od-mini]', track).forEach(function (card) {
        var inBag = ids && ids[card.dataset.productId];
        var show = !inBag && shown < want;
        card.hidden = !show;
        if (show) shown++;
      });
      root.hidden = shown === 0;
    }

    var url = (root.dataset.url || ROOT + 'recommendations/products') +
      '?product_id=' + encodeURIComponent(root.dataset.productId) +
      '&intent=complementary&limit=' + (want + 2) + '&section_id=od-pdp-xsell';

    var pairings = fetch(url)
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var cards = $$('[data-od-xsell-recs] [data-od-mini]', doc);
        if (!cards.length) return;
        // merchant pairings lead; collection cards they duplicate are dropped
        var seen = {};
        var frag = document.createDocumentFragment();
        cards.forEach(function (c) {
          if (c.dataset.productId === root.dataset.productId) return;
          seen[c.dataset.productId] = true;
          frag.appendChild(document.importNode(c, true));
        });
        $$('[data-od-mini]', track).forEach(function (c) {
          if (seen[c.dataset.productId]) c.remove();
        });
        track.insertBefore(frag, track.firstChild);
        $$('[data-od-mini]', track).forEach(bindMini);
      })
      .catch(function () { /* the collection row stays */ });

    Promise.all([pairings, cartProductIds()]).then(function (r) { settle(r[1]); });

    document.addEventListener('od:cart:changed', function () {
      cartProductIds().then(settle);
    });
  }

  /* -------------------------------------------------- 2. complete the look */

  function mainForm() {
    return $('.od-pdp__form');
  }

  function mainVariant() {
    var input = $('.od-pdp__form [name="id"]');
    var data = $('[data-od-variant-data]');
    var variants = [];
    if (data) { try { variants = JSON.parse(data.textContent) || []; } catch (e) {} }
    var id = input ? Number(input.value) : 0;
    for (var i = 0; i < variants.length; i++) if (variants[i].id === id) return variants[i];
    return null;
  }

  // the short label of the size the shopper has chosen on the main form
  function mainSizeLabel() {
    var groups = $$('.od-pdp [data-od-variants] .od-variants__group');
    var sizeName = ((cfg.sizeOption || 'size') + '').toLowerCase();
    var label = '';
    groups.forEach(function (g) {
      var legend = $('legend', g);
      var name = legend ? (legend.childNodes[0] && legend.childNodes[0].textContent || legend.textContent) : '';
      if (name.trim().toLowerCase().indexOf(sizeName) !== 0 && groups.length > 1) return;
      var checked = $('input[type="radio"]:checked', g);
      var sel = $('select', g);
      if (checked) label = checked.dataset.odLabel || checked.value;
      else if (sel && sel.selectedOptions[0]) label = sel.selectedOptions[0].dataset.odLabel || sel.value;
    });
    return label;
  }

  function upsell(root) {
    if (root.dataset.odUpBound) return;
    root.dataset.odUpBound = '1';

    var form = $('[data-od-up-form]', root);
    var totalEl = $('[data-od-up-total]', root);
    var countEl = $('[data-od-up-count]', root);
    var btn = $('[data-od-up-add]', root);
    var btnText = $('[data-od-up-add-text]', root);
    var msg = $('[data-od-up-msg]', root);
    var format = root.dataset.moneyFormat;
    var restore = btnText ? btnText.textContent : '';
    if (!form) return;

    var items = $$('[data-od-up-item]', root);

    function priceOf(item) {
      var sel = $('select[data-od-up-id]', item);
      if (sel) {
        var opt = sel.selectedOptions && sel.selectedOptions[0];
        return opt ? Number(opt.dataset.price) || 0 : 0;
      }
      var hid = $('input[data-od-up-id]', item);
      return hid ? Number(hid.dataset.price) || 0 : 0;
    }

    function included(item) {
      var check = $('[data-od-up-check]', item);
      return !check || check.checked;
    }

    function recalc() {
      var sum = 0;
      var n = 0;
      items.forEach(function (item) {
        var on = included(item);
        item.classList.toggle('is-off', !on);
        var sel = $('select[data-od-up-id]', item);
        if (sel) sel.disabled = !on;
        if (!on) return;
        sum += priceOf(item);
        n++;
        var priceEl = $('[data-od-up-price]', item);
        var opt = sel && sel.selectedOptions && sel.selectedOptions[0];
        if (priceEl && opt && opt.dataset.priceText) priceEl.textContent = opt.dataset.priceText;
      });
      if (totalEl) totalEl.textContent = formatMoney(sum, format);
      if (countEl) {
        countEl.textContent = n === 1
          ? (root.dataset.labelOne || '')
          : (root.dataset.labelMany || '').replace('[count]', n);
      }
      if (btn) btn.disabled = n === 0;
    }

    // the piece being viewed follows the main form: variant, price, size
    function syncMain() {
      var v = mainVariant();
      var thisItem = $('[data-od-up-this]', root);
      if (!thisItem) return;
      var hid = $('[data-od-up-main]', thisItem);
      var priceEl = $('[data-od-up-price]', thisItem);
      var chosen = $('[data-od-up-chosen]', thisItem);
      if (v && hid) {
        hid.value = v.id;
        hid.dataset.price = v.price;
        if (priceEl) priceEl.textContent = formatMoney(v.price, format);
        if (chosen) chosen.textContent = v.title && v.title !== 'Default Title' ? v.title : '';
      }
      var mainAvailable = v ? v.available : false;
      thisItem.classList.toggle('is-off', !mainAvailable);

      // suggested pieces take the same size when they have it
      var label = mainSizeLabel().toLowerCase();
      if (label) {
        $$('select[data-od-up-id]', root).forEach(function (sel) {
          for (var i = 0; i < sel.options.length; i++) {
            if ((sel.options[i].dataset.label || '').toLowerCase() === label) {
              sel.selectedIndex = i;
              break;
            }
          }
        });
      }
      recalc();
    }

    $$('[data-od-up-check], select[data-od-up-id]', root).forEach(function (el) {
      el.addEventListener('change', recalc);
    });

    var mf = mainForm();
    if (mf) {
      $$('.od-variants__input, [data-od-option-select]', document).forEach(function (el) {
        // after od-product.js has updated the hidden variant input
        el.addEventListener('change', function () { setTimeout(syncMain, 0); });
      });
    }

    form.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      var v = mainVariant();
      var list = [];
      items.forEach(function (item) {
        if (!included(item)) return;
        var input = $('[data-od-up-id]', item);
        if (!input || !input.value) return;
        if (item.hasAttribute('data-od-up-this') && v && !v.available) return;
        list.push({ id: Number(input.value), quantity: 1 });
      });
      if (!list.length) return;
      btn.disabled = true;
      if (msg) { msg.hidden = true; msg.textContent = ''; }
      addItems(list)
        .then(function () {
          flash(btn, btnText, list.length === 1 ? 'Added to your bag' : 'All added to your bag', restore);
        })
        .catch(function (err) {
          if (msg) { msg.textContent = err.message; msg.hidden = false; }
        })
        .then(function () { btn.disabled = false; });
    });

    syncMain();
  }

  /* ------------------------------------------------------- 3. icons row */

  function iconsRow(root) {
    if (root.dataset.odIconsBound) return;
    root.dataset.odIconsBound = '1';
    var min = parseInt(root.dataset.min, 10) || 3;

    function dedupe() {
      var shown = {};
      $$('[data-od-recs] [data-od-card]').forEach(function (c) { shown[c.dataset.productHandle] = true; });
      var left = 0;
      $$('[data-od-card]', root).forEach(function (c) {
        var dup = !!shown[c.dataset.productHandle];
        c.hidden = dup;
        if (!dup) left++;
      });
      root.hidden = left < min;
    }

    dedupe();
    var recs = $('[data-od-recs]');
    if (recs && 'MutationObserver' in window) {
      new MutationObserver(dedupe).observe(recs, { childList: true, subtree: true });
    }
  }

  /* --------------------------------------- 4. add to bag bar on phones */

  function stickyBar(bar) {
    if (bar.dataset.odSatcBound) return;
    bar.dataset.odSatcBound = '1';

    var section = bar.closest('section') || document.body;
    var mainBtn = $('[data-od-add]', section);
    var mainPrice = $('[data-od-price] .od-pdp__now', section);
    var priceEl = $('[data-od-satc-price]', bar);
    var sizeBtn = $('[data-od-satc-size]', bar);
    var sizeText = $('[data-od-satc-size-text]', bar);
    var addBtn = $('[data-od-satc-add]', bar);
    var addText = $('[data-od-satc-add-text]', bar);
    var picker = $('[data-od-variants]', section);
    if (!mainBtn || !addBtn) return;

    bar.hidden = false;
    section.classList.add('od-pdp--has-satc');

    var mq = window.matchMedia('(max-width: 989px)');
    var mainVisible = true;
    // the set further down has its own button; the bar steps aside for it
    var setTotal = $('[data-od-up-add]');
    var setVisible = false;

    function place() {
      var show = mq.matches && !mainVisible && !setVisible;
      bar.classList.toggle('is-shown', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      if ('inert' in bar) bar.inert = !show;
    }

    function mirror() {
      if (priceEl && mainPrice) priceEl.textContent = mainPrice.textContent;
      var v = mainVariant();
      if (sizeText) {
        var labels = $$('[data-od-chosen]', section).map(function (el) { return el.textContent.trim(); }).filter(Boolean);
        sizeText.textContent = labels.length ? labels.join(' · ') : (v && v.title !== 'Default Title' ? v.title : '');
      }
      addBtn.disabled = mainBtn.disabled;
      var mainText = $('[data-od-add-text]', mainBtn);
      if (addText && mainText) addText.textContent = mainText.textContent.trim();
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          // "out of view" only once it has scrolled up past the top, not
          // before the shopper has reached it
          mainVisible = en.isIntersecting || en.boundingClientRect.top > 0;
        });
        place();
      }, { threshold: 0 }).observe(mainBtn);
      if (setTotal) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { setVisible = en.isIntersecting; });
          place();
        }, { threshold: 0, rootMargin: '0px 0px 90px 0px' }).observe(setTotal);
      }
    }
    if (mq.addEventListener) mq.addEventListener('change', place);
    else if (mq.addListener) mq.addListener(place);

    if ('MutationObserver' in window) {
      var mo = new MutationObserver(mirror);
      mo.observe(mainBtn, { attributes: true, childList: true, subtree: true, characterData: true });
      if (mainPrice) mo.observe(mainPrice, { childList: true, characterData: true, subtree: true });
      $$('[data-od-chosen]', section).forEach(function (el) {
        mo.observe(el, { childList: true, characterData: true, subtree: true });
      });
    }

    addBtn.addEventListener('click', function () {
      if (mainBtn.disabled) {
        if (picker) picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      mainBtn.click();
    });

    if (sizeBtn && picker) {
      sizeBtn.addEventListener('click', function () {
        picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
        var first = $('input:checked, input, select', picker);
        if (first) setTimeout(function () { try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); } }, 450);
      });
    }

    mirror();
    place();
  }

  /* ------------------------------------------------------------- init */

  function init(ctx) {
    $$('[data-od-xsell]', ctx).forEach(crossSell);
    $$('[data-od-upsell]', ctx).forEach(upsell);
    $$('[data-od-pdp-icons]', ctx).forEach(iconsRow);
    $$('[data-od-satc]', ctx).forEach(stickyBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
